import { ReactComponent as OutlineWarningCircle } from "assets/svg/outline-warning-circle-red.svg";
import { ReactComponent as OutlineCross } from "assets/svg/outline-cross.svg";
import styles from "./ErrorBanner.module.scss";

interface Props {
  onClose: () => void;
  message: string;
  tryAgain: () => void;
}

const ErrorBanner = ({ onClose, message, tryAgain }: Props) => {
  return (
    <div className={styles["error-banner-wrapper"]}>
      <div className={styles["error-banner-text"]}>
        <OutlineWarningCircle />
        {message}
        <div className={styles["error-banner-try-again"]} onClick={tryAgain}>
          Try Again
        </div>
      </div>
      <OutlineCross
        onClick={onClose}
        className={styles["error-banner-close-icon"]}
      />
    </div>
  );
};

export default ErrorBanner;
